<template>
    <section>
        <div class="row">
            <div class="col-12">
                <div class="gadget-search-box">
                    <b-icon icon="search"></b-icon>
                    <input type="text" placeholder="ชื่อลูกค้า / เลขประจำตัวผู้เสียภาษี" v-model="formFilter.keyword" @keyup.enter="submitFilter()" />
                    <button class="btn btn-danger" @click="submitFilter()">ค้นหา</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    data() {
        return {
            formFilter: ModelKeywordFilter.data()
        }
    },
    methods: {
        submitFilter() {
            this.$emit('lookup', this.formFilter);
        }
    }
}
</script>